export default __webpack_public_path__ + "static/media/Main.871ace7e.png";